import { render } from "./MealsDisplay.vue?vue&type=template&id=5527aebd"
import script from "./MealsDisplay.vue?vue&type=script&lang=js"
export * from "./MealsDisplay.vue?vue&type=script&lang=js"

import "./MealsDisplay.vue?vue&type=style&index=0&id=5527aebd&lang=scss"

import exportComponent from "C:\\Users\\The Knight\\Desktop\\Cashoo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__